// src/components/TeamMemberModal.js
import React, { useEffect } from 'react';

const TeamMemberModal = ({ member, isOpen, onClose }) => {
  // Cerrar con ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4 transition-all duration-300"
      onClick={onClose}
    >
      <div 
        className="rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto border animate-fadeInUp"
        style={{ backgroundColor: '#211F1F', borderColor: '#333' }}
        onClick={(e) => e.stopPropagation()}
      >
        
        {/* Header con botón cerrar */}
        <div className="sticky top-0 flex justify-end p-4 backdrop-blur-sm z-10 border-b" style={{ backgroundColor: '#211F1FCC', borderColor: '#333' }}>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-[#E8B00C] transition-all duration-300 transform hover:scale-110"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Contenido del modal */}
        <div className="p-6 md:p-8">
          
          {/* Foto circular + información principal */}
          <div className="flex flex-col items-center text-center mb-6">
            {/* Foto completamente circular */}
            <div 
              className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border-4 shadow-xl mb-4"
              style={{ borderColor: '#E8B00C', backgroundColor: '#211F1F' }}
            >
              <img 
                src={member.photo} 
                alt={member.name}
                className="w-full h-full object-cover object-center"
                style={{
                  objectPosition: member.name.includes('Evelio') ? 'center 20%' : 'center top'
                }}
              />
            </div>
            
            {/* Nombre y experiencia */}
            <div className="flex flex-wrap items-center justify-center gap-2 mb-2">
              <h2 className="text-2xl md:text-3xl font-bold" style={{ color: 'white' }}>
                {member.name}
              </h2>
              <span className="text-sm font-semibold px-3 py-1 rounded-full border" style={{ color: '#E8B00C', backgroundColor: '#E8B00C20', borderColor: '#E8B00C30' }}>
                {member.experience}
              </span>
            </div>
            
            {/* Posición */}
            <p className="font-semibold text-base md:text-lg mb-1" style={{ color: '#E8B00C' }}>
              {member.position}
            </p>
            
            {/* Especialidad */}
            <p className="text-gray-400 text-sm md:text-base">
              {member.specialty}
            </p>
          </div>
          
          {/* Descripción profesional */}
          <div className="mb-6">
            <h3 className="text-lg md:text-xl font-semibold mb-3 border-l-3 pl-3" style={{ color: '#E8B00C', borderLeftColor: '#E8B00C' }}>
              Perfil profesional
            </h3>
            <div className="text-gray-300 text-base md:text-lg leading-relaxed whitespace-pre-line text-justify">
              {member.description.split('\n').map((paragraph, idx) => (
                <p key={idx} className="mb-3">{paragraph}</p>
              ))}
            </div>
          </div>
          
          {/* Formación académica */}
          <div className="mb-6">
            <h3 className="text-lg md:text-xl font-semibold mb-3 border-l-3 pl-3" style={{ color: '#E8B00C', borderLeftColor: '#E8B00C' }}>
              Formación académica
            </h3>
            <ul className="list-disc list-inside text-gray-300 text-base md:text-lg space-y-2">
              {member.education.map((item, idx) => (
                <li key={idx} className="break-words">{item}</li>
              ))}
            </ul>
          </div>
          
          {/* Contacto */}
          <div className="pt-4 border-t" style={{ borderColor: '#333' }}>
            <a
              href={`mailto:${member.email}`}
              className="inline-flex items-center text-gray-400 hover:text-[#E8B00C] transition-all duration-300 group text-sm md:text-base"
            >
              <svg className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-18 4v7a2 2 0 002 2h14a2 2 0 002-2v-7"/>
              </svg>
              {member.email}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMemberModal;